'use strict';

require('./sidebar');

require('./addresses');